import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";
import {
    CategoryDefinitionId,
    IFilterCategoryDefinition
} from "../../filters-categories-definitions/filter-category-definition.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {computed} from "mobx";
import {GameInfo} from "../../../games/game-info";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {IArenaGameFilter} from "../filters/arena-game-filter.interface";
import {NullableNumber} from "../../../../../common/types/nullable-types";

export abstract class ArenaGameFiltersCategoryBase implements IArenaGameFiltersCategory {
    constructor(protected readonly categoryDefinition: IFilterCategoryDefinition,
                protected readonly services: IServiceFactoryExtended) {
    }

    abstract get availableFilters(): IArenaGameFilter[];
    abstract get gamesCount(): NullableNumber;


    get id(): CategoryDefinitionId {
        return this.categoryDefinition.id;
    }

    get title(): string {
        return this.categoryDefinition.title;
    }

    get isMultiSelect(): boolean {
        return this.categoryDefinition.isMultiSelect;
    }

    @computed
    private get _appliedFilters(): IArenaGameFilter[] {
        return this.availableFilters.filter(f => f.isApplied);
    }

    @computed
    private get _appliedSubFilters(): IArenaGameFilter[] {
        return this.availableFilters.selectMany(f => f.subFilters.filter(sf => sf.isApplied));
    }

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {

        const appliedFilters = this._appliedFilters;
        const appliedSubFilters = this._appliedSubFilters;

        if(appliedFilters.length === 0 && appliedSubFilters.length === 0) {
            return ApplyGameFilterResult.NotApplicable;
        }

        return this.categoryDefinition.applyFilters(gameInfo,
                                                    appliedFilters.map(arenaFilter => arenaFilter.filterDefinition),
                                                    appliedSubFilters.map(subFilter => subFilter.filterDefinition));
    }

    isGameIncludedInThisCategory(gameInfo: GameInfo): boolean {
        return this.availableFilters.some(f => f.applyFilter(gameInfo) === ApplyGameFilterResult.IncludeGame);
    }


}